import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Heading } from '@/components/Cms/Heading';
import type { Maybe } from '@/lib/types';
export const HistoryItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HistoryItemImageGroup = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(5)};
    }
    margin-bottom: ${theme.spacing(4)};
  `}
`;
export const HistoryItemImage = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HistoryItemDoYouKonw = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ImageWrapper = styled(Box)`
  position: relative;
  overflow: hidden;
`;

export const Media = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  position: absolute;

  ${({ $backgroundAlignment, theme }) => css`
    ${theme.media.md.down} {
      object-position: ${$backgroundAlignment || 'center'};
    }
  `}
`;

export const DisplayDidYouKnowGroup = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    background-color: ${theme.colors.primaryLight};
    margin-top: ${theme.spacing(2.5)};
    padding: ${theme.spacing(2)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(3)};
    }
  `}
`;

export const DisplayDidYouKnowLabel = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes.h4};
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;

    ${theme.media.md.up} {
      text-align: left;
    }
  `}
`;
export const DisplayDidYouKnowText = styled(Box)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    line-height: 22px;
    font-weight: 400;
    text-align: center;
    ${theme.media.md.up} {
      text-align: left;
    }
    white-space: pre-wrap;
  `}
`;

export const HistoryInfoGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HistoryInfoTitle = styled(Heading)`
  ${({ theme }) => css`
    text-align: center !important;
    margin-top: ${theme.spacing(4)};

    ${theme.media.md.up} {
      text-align: left !important;
      white-space: normal;
      margin-top: ${theme.spacing(5)};
    }
  `}
`;
export const HistoryInfoSubTitle = styled(Box)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h4};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: 600;
    text-align: center;
    margin-bottom: ${theme.spacing(1.25)};
    ${theme.media.md.up} {
      text-align: left;
      white-space: normal;
    }
  `}
`;

export const HistoryInfoText = styled(DisplayDidYouKnowText)`
  white-space: pre-wrap;
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(3)};
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(4)};
    }
    p {
      margin-bottom: ${theme.spacing(3)};
      ${theme.media.md.up} {
        margin-bottom: ${theme.spacing(4)};
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  `}
`;
